<div class="row">

    <div class="col-lg-10 col-md-10 col-xs-12 col-sm-12" >
        <div id="content"></div>
    </div>

  
    <div class="col-lg-2 col-md-2 col-xs-12 col-sm-12"></div>
</div>

